export default class CACA1060RequestModel {
  productNo: string
  shhnCd: string
}
